<template>
  <div class="modal fade" id="warning" tabindex="-1" aria-labelledby="warning" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-gradient-danger" id="warningModalHeader">
          <h5 class="modal-title" id="warningModalLabel"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <h4>آیا از حذف {{ customer.title }} اطمینان دارید؟!</h4>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn bg-gradient-success" data-bs-dismiss="modal">خیر</button>
          <button type="button" class="btn bg-gradient-danger" data-bs-dismiss="modal"
            @click="deleteCustomer">حذف</button>
        </div>
      </div>
    </div>
  </div>
  <div class="py-4 container-fluid">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div v-if="getPermission(1060).view" class="col-md-4">
            <label class="form-control-label">انتخاب شرکت برای نمایش مشتریان</label>
            <treeselect v-model="companyId" :multiple="false" placeholder="انتخاب کنید" :showCount="true"
              noOptionsText="هنوز شرکتی تعریف نشده است" noResultsText="موردی یافت نشد"
              noChildrenText="این شرکت فاقد زیر مجموعه است" :options="companies" @open="reloadCompanies" @select="" />
          </div>
          <div class="col-md-4">
            <label class="form-control-label">انتخاب مشتری برای نمایش فرزندان</label>
            <treeselect v-model="parentId" :multiple="false" placeholder="انتخاب کنید" :showCount="true"
              noOptionsText="هنوز مشتری ای تعریف نشده است" noResultsText="موردی یافت نشد"
              noChildrenText="این مشتری فاقد زیر مجموعه است" :options="parents" @open="reloadCustomers" @select="" />
          </div>
        </div>
        <div>
          <hr class="horizontal dark" />
        </div>
        <div class="table-responsive p-0">
          <table class="table table-striped table-styled table-sm">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">نام مشتری</th>
                <th scope="col">شهر</th>
                <th scope="col">تلفن مشتری</th>
                <th scope="col">آدرس</th>
                <th v-if="parentId" scope="col">شرکت</th>
                <th v-if="companyId" scope="col">والد</th>
                <th scope="col">سقف کاربران فعال</th>
                <th scope="col">تاریخ اعتبار</th>
                <th scope="col">امکانات</th>
              </tr>
            </thead>
            <tbody>
              <tr></tr>
              <tr v-for="(c, index) in customers">
                <td>{{ index + 1 }}</td>
                <td>{{ c.title }}</td>
                <td>{{ c.countryTitle }} - {{ c.provinceTitle }} - {{ c.countyTitle }}</td>
                <td>{{ c.phone }}</td>
                <td>{{ c.address }}</td>
                <td v-if="parentId">{{ c.companyTitle }}</td>
                <td v-if="companyId">{{ c.parentTitle }}</td>
                <td>{{ c.maxActiveUsers }}</td>
                <td>{{ this.$filters.toDateString(c.expirationDate) }}</td>
                <td>
                  <button v-if="getPermission(1060).update | getPermission(1110).update | !this.$store.state.currentUserInfo.isCompanyUser" class="btn btn-sm bg-gradient-warning mb-0" @click="goToEdit(c.id)" title="ویرایش">
                    <fa-icon icon="fas fa-pencil" />
                  </button>
                  <button v-if="getPermission(1060).delete | getPermission(1110).delete | !this.$store.state.currentUserInfo.isCompanyUser" class="btn btn-sm bg-gradient-danger mb-0" @click="setCustomer(c)" data-bs-toggle="modal"
                  data-bs-target="#warning" title="حذف">
                  <fa-icon icon="fas fa-trash" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <hr class="horizontal dark" />
      </div>
      <div>
        <button v-if="getPermission(1060).insert | getPermission(1110).insert | !this.$store.state.currentUserInfo.isCompanyUser" class="btn bg-gradient-success mb-0" @click="goToAddCustomer">اضافه کردن مشتری جدید</button>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import CustomerService from "@/services/Company/Customer-service.js";
import Treeselect from '@cholakovdev/vue3-treeselect';
import { mapMutations, mapGetters } from "vuex";

export default {
  components: { Treeselect },
  data() {
    return {
      customers: [],
      customer: {},
      companies: [],
      companyId: null,
      parents: [],
      parentId: null,
      oldId: null
    };
  },
  computed:{
    ...mapGetters(['getPermission']),
  },
  watch: {
    companyId(company) {
      if (typeof (company) === 'number' && typeof (this.parentId) === 'number' && this.getPermission(1060).view) {
        this.parents = [{ id: this.parentId, label: '', pH: true }];
        this.oldId = this.parentId;
        this.parentId = null;
      }

      if (typeof (company) === 'number') {
        this.getCustomersByCompany();
      }
      else {
        this.customers = [];
      }
    },
    parentId(customer) {
      if (typeof (customer) === 'number' && typeof (this.companyId) === 'number' && this.getPermission(1060).view) {
        this.companies = [{ id: this.companyId, label: '', pH: true }];
        this.oldId = this.companyId;
        this.companyId = null;
      }

      if (typeof (customer) === 'number') {
        this.getCustomersByCustomer();
      }
      else if(typeof (this.companyId) === 'number'){
        this.getCustomersByCompany();
      }
      else {
        this.customers = [];
      }
    },
  },
  methods: {
    ...mapMutations(["setCurrentUserInfo"]),
    getCustomersByCompany() {
      setTimeout(() =>
        CustomerService.getCustomersByCompanyId(this.companyId).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          }
          else {
            this.customers = result.data;
          }
        }).catch(e => {
          console.log(e);
        }),
        100);
    },
    getCustomersByCustomer() {
      setTimeout(() =>
        CustomerService.getCustomersByParentId(this.parentId).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          }
          else {
            this.customers = result.data;
          }
        }).catch(e => {
          console.log(e);
        }),
        100);
    },
    goToAddCustomer() {
      this.$router.push('/addCustomer');
    },
    goToEdit(customerId) {
      this.$router.push('/updateCustomer/' + customerId);
    },
    setCustomer(customer) {
      this.customer = customer;
    },
    deleteCustomer() {
      CustomerService.deleteCustomer(this.customer.id).then(response => {
        let result = response.data;

        if (result.success) {
          this.$toast.success(result.message);

          if (this.$store.state.currentUserInfo.isCompanyUser) {
            this.getUserCustomersByCompany(this.$store.state.currentUserInfo.companies.allIds);
          }
          else {
            this.getUserCustomersByCustomer(this.$store.state.currentUserInfo.customerId);
          }

          let index = this.customers.indexOf(this.customer);
          this.customers.splice(index, 1);
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    reloadCompanies() {
      if (this.companies[0].pH & this.getPermission(1060).view) {
        this.companyId = this.oldId;
        this.companies = [];
        this.companies.push(this.$store.state.currentUserInfo.companies);
      }
    },
    reloadCustomers() {
      if (this.parents[0].pH & this.getPermission(1060).view) {
        this.parentId = this.oldId;
        this.parents = [];
        this.parents = this.$store.state.currentUserInfo.customers;
      }
    },
    getUserCustomersByCompany(companyIds) {
      CustomerService.getUserCustomersByCompany(companyIds).then(response => {
        let result = response.data;

        if (result.success) {
          this.setCurrentUserInfo({ customers: result.data });

          if (this.companies[0].pH) {
            setTimeout(() => {
              this.parents = [];
              this.parents = this.$store.state.currentUserInfo.customers;
            }, 500);
          }
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getUserCustomersByCustomer(customerId) {
      CustomerService.getUserCustomersByCustomer(customerId).then(response => {
        let result = response.data;

        if (result.success) {
          this.setCurrentUserInfo({ customers: result.data });

          if (this.companies[0].pH) {
            setTimeout(() => {
              this.parents = [{ id: this.parentId, label: '', pH: true }];
              this.parents = [];
              this.parents.push(this.$store.state.currentUserInfo.customers);
            }, 500);
          }
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
  },
  created() {
    if (this.$store.state.currentUserInfo.companies) {
      this.companies.push(this.$store.state.currentUserInfo.companies);
      this.parents = this.$store.state.currentUserInfo.customers;
      if(this.getPermission(1060).view | this.getPermission(1110).view) {
        this.companyId = this.$store.state.currentUserInfo.companies.id;
      }
    }
    else {
      this.parents.push(this.$store.state.currentUserInfo.customers);
      this.parentId = this.$store.state.currentUserInfo.customers.id;
    }
  }
}
</script>